import React, { useState } from 'react';
import './FeedbackForm.css';

export default function FeedbackForm() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating trigger button */}
      <button
        className="feedback-fab"
        onClick={() => setOpen(true)}
        aria-label="Open feedback form"
        title="Feedback / Inquiry"
      >
        <span>📝</span>
        <span className="fab-label">Feedback</span>
      </button>

      {/* Modal overlay */}
      {open && (
        <div className="feedback-overlay" onClick={() => setOpen(false)}>
          <div
            className="feedback-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="feedback-header">
              <h3>Feedback & Inquiry</h3>
              <button
                className="feedback-close"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSetsi38B7EqdpTj4-xWCEWbmKxwMXc3vk3R1j_8nK80k3ZqBw/viewform?embedded=true"
              title="Feedback and Inquiry Form"
              width="100%"
              height="520"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
            >
              Loading…
            </iframe>
          </div>
        </div>
      )}
    </>
  );
}
